/** ----------------------------------------
     Module Interface
 ---------------------------------------- */

import module from './interface';

/** ----------------------------------------
    Module
 ---------------------------------------- */

import merge from 'lodash/merge';

/** ----------------------------------------
    Helper
 ---------------------------------------- */

const isObject = value => {
    if (value === null) return false;
    return ((typeof value === 'function') || (typeof value === 'object'));
};

/** ----------------------------------------
    State
 ---------------------------------------- */

const getters = {

    /** ----------------------------------------
         All Cases
     ---------------------------------------- */

    getTeams: state => {
        return state.data;
    },

    /** ----------------------------------------
         Person by Name
     ---------------------------------------- */

    getPersonByName: state => name => {
        let person = [];
        const findName = obj => obj.name === name;

        state.data.forEach(team => {
            const members = team.members;
            const match = members.find(findName);
            isObject(match) && person.push(match);
        });

        return person[0];
    },

    /** ----------------------------------------
         Persons by Name
     ---------------------------------------- */

    getPersonsByName: state => names => {
        let persons = [];

        names.forEach(name => {
            const findName = obj => obj.name === name;

            state.data.forEach(team => {
                const members = team.members;
                const match = members.find(findName);
                isObject(match) && persons.push(match);
            });
        });

        return [{
            members: persons
        }];
    }

};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default getters